import {buildRoute, ROUTES} from '../../configs/routes';
import URL_MAP from '../../constants/urls';
import {
  AdminPanelIcon, CalendarIcon, ChatIcon, CloseVacancyIcon, ContactsIcon, ControlPanelIcon,
  DbHostoryIcon, FavoriteResumeIcon, FavoriteVacansyIcon, FeedBackIcon,
  FeedPageIcon, FindResumeSidebarIcon, FindVacancyIcon, FlowRequestIcon, HelpIcon,
  InvitesIcon, MailIcon, MyVideoQuestionIcon, MyVideosessionIcon,
  NotificationIcon, PaymentPanelIcon, PortfolioIcon, RecordRequestIcon,
  ResumeIcon, SelectionRequestIcon, StartVideosessionIcon, StatisticIcon,
  TaskControlIcon, TaskIcon, VacancyIcon, MyVideosIcon, VideoBusinessCardIcon,
  VideoNewVcIcon, VideoVideovacancyIcon,
} from '../SvgComponents/SvgComponents';

const generalFeed = {
  text: 'nav.feed',
  route: buildRoute(URL_MAP.FEED),
  disabled: false,
  iconComponent: FeedPageIcon,
};
const searchVacancy = {
  text: 'nav.findVacancy',
  route: '#',
  disabled: true,
  iconComponent: FindVacancyIcon,
};
const searchResume = {
  text: 'nav.findCv',
  route: '#',
  disabled: true,
  iconComponent: FindResumeSidebarIcon,
};
const myVideoSessions = {
  text: 'nav.myVideosessions',
  route: ROUTES.MY_VIDEO_SESSION.route,
  disabled: false,
  iconComponent: MyVideosIcon,
  indent: true,
};
const candMyVideoPolls = {
  text: 'nav.myVideoSurveys',
  route: ROUTES.MY_VIDEO_POLL.route,
  disabled: false,
  iconComponent: MyVideoQuestionIcon,
  quantityKey: 'newVideoPollCount',
};
const emplMyVideoPolls = {
  text: 'nav.myVideoSurveys',
  route: ROUTES.VIDEO_POLLS.route,
  disabled: false,
  iconComponent: MyVideoQuestionIcon,
  quantityKey: 'newVideoPollCount',
};
const myResumes = {
  text: 'nav.resume',
  route: '#',
  disabled: true,
  iconComponent: ResumeIcon,
};
const favoriteVacancies = {
  text: 'nav.favoriteVacancies',
  route: '#',
  disabled: true,
  iconComponent: FavoriteVacansyIcon,
};
const myPortfolio = {
  text: 'nav.myPortfolio',
  route: URL_MAP.PORTFOLIO,
  disabled: false,
  iconComponent: PortfolioIcon,
};
const responsesAndInvitations = {
  text: 'nav.responsesAndInvitations',
  route: '#',
  disabled: true,
  iconComponent: InvitesIcon,
};
const databaseHistory = {
  text: 'nav.dbHistory',
  route: '#',
  disabled: true,
  iconComponent: DbHostoryIcon,
};
const mail = {
  text: 'nav.mail',
  route: '#',
  disabled: true,
  iconComponent: MailIcon,
};
const calendar = {
  text: 'nav.calendar',
  route: '#',
  disabled: true,
  iconComponent: CalendarIcon,
};
const contacts = {
  text: 'nav.contacts',
  route: ROUTES.PROFILE_CONTACTS.route,
  disabled: false,
  iconComponent: ContactsIcon,
};
const notifications = {
  text: 'nav.notifications',
  route: '#',
  disabled: true,
  iconComponent: NotificationIcon,
  submenu: [
    mail,
    calendar,
    databaseHistory,
  ],
};
const chats = {
  text: 'nav.chats',
  route: '#',
  disabled: true,
  iconComponent: ChatIcon,
};
const help = {
  text: 'nav.help',
  route: ROUTES.HELP.route,
  disabled: true,
  iconComponent: HelpIcon,
};
const feedback = {
  text: 'nav.feedback',
  route: ROUTES.FEEDBACK.route,
  disabled: false,
  iconComponent: FeedBackIcon,
};
const requestForSelection = {
  text: 'nav.selection',
  route: '#',
  disabled: true,
  iconComponent: SelectionRequestIcon,
};
const requestForFlow = {
  text: 'nav.flow',
  route: '#',
  disabled: true,
  iconComponent: FlowRequestIcon,
};
const requestForRecord = {
  text: 'nav.requestForRecording',
  route: ROUTES.RECORD_REQUEST.route,
  disabled: true,
  iconComponent: RecordRequestIcon,
  submenu: [
    requestForFlow,
    requestForSelection,
  ],
};
const myVacancies = {
  text: 'nav.vacancies',
  route: '#',
  disabled: true,
  iconComponent: VacancyIcon,
};
const closeVacancies = {
  text: 'nav.closeVacancy',
  route: '#',
  disabled: true,
  iconComponent: CloseVacancyIcon,
};
const favoriteResumes = {
  text: 'nav.favoriteCv',
  route: '#',
  disabled: true,
  iconComponent: FavoriteResumeIcon,
};

const controlPanel = {
  text: 'nav.controlPanel',
  route: ROUTES.CONTROL_PANEL.route,
  disabled: false,
  iconComponent: ControlPanelIcon,
};
const tasksManagement = {
  text: 'nav.jobManagement',
  route: '#',
  disabled: true,
  iconComponent: TaskControlIcon,
};
const adminPanel = {
  text: 'nav.adminPanel',
  route: ROUTES.ADMIN_PANEL.route,
  disabled: false,
  iconComponent: AdminPanelIcon,
};
const statistic = {
  text: 'nav.statistic',
  route: '#',
  disabled: true,
  iconComponent: StatisticIcon,
};
const myTasks = {
  text: 'Мои задания',
  route: '#',
  disabled: true,
  iconComponent: TaskIcon,
};
const paymentsPanel = {
  text: 'Панель оплат',
  route: '#',
  disabled: true,
  iconComponent: PaymentPanelIcon,
};
const videoSession = {
  text: 'nav.startVideosession',
  route: buildRoute(URL_MAP.VIDEO_SESSION),
  disabled: false,
  iconComponent: StartVideosessionIcon,
};
const videoResume = {
  text: 'nav.recordVideoCv',
  route: buildRoute(URL_MAP.VIDEO_RESUME),
  disabled: false,
  iconComponent: VideoNewVcIcon,
};
const videoVacancy = {
  text: 'nav.recordVideoVacancy',
  route: buildRoute(URL_MAP.VIDEO_VACANCY),
  disabled: false,
  iconComponent: VideoVideovacancyIcon,
};
const videoBusinessCard = {
  text: 'nav.videoBusinessCardRecording',
  route: buildRoute(URL_MAP.VIDEO_BUSINESS_CARD),
  disabled: false,
  iconComponent: VideoBusinessCardIcon,
};
const myVideoResume = {
  text: 'nav.myVideoCv',
  route: ROUTES.MY_VIDEO_RESUME.route,
  disabled: false,
  iconComponent: MyVideosIcon,
  indent: true,
};
const myVideoVacancy = {
  text: 'nav.myVideovacancies',
  route: ROUTES.MY_VIDEO_VACANCY.route,
  disabled: false,
  iconComponent: MyVideosIcon,
  indent: true,
};
const myVideoBusinessCard = {
  text: 'nav.myVideoBusinessCard',
  route: ROUTES.MY_VIDEO_BUSINESS_CARD.route,
  disabled: false,
  iconComponent: MyVideosIcon,
  indent: true,
};

export const guestLinks = [
  generalFeed,
  videoSession,
  searchVacancy,
  searchResume,
];

export const candidatesLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  videoResume,
  myVideoResume,
  candMyVideoPolls,
  notifications,
  myResumes,
  searchVacancy,
  favoriteVacancies,
  myPortfolio,
  responsesAndInvitations,

  contacts,
  chats,
  help,
  feedback,
  requestForRecord,
]; // 3,

export const employerLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  videoVacancy,
  myVideoVacancy,
  videoBusinessCard,
  myVideoBusinessCard,
  emplMyVideoPolls,
  notifications,
  myVacancies,
  closeVacancies,
  searchResume,
  favoriteResumes,
  responsesAndInvitations,

  contacts,
  chats,
  help,
  feedback,
  requestForRecord,
]; // 4 , 5,

export const adminLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  videoResume,
  myVideoResume,
  videoVacancy,
  myVideoVacancy,
  videoBusinessCard,
  myVideoBusinessCard,
  notifications,
  controlPanel,
  tasksManagement,
  adminPanel,
  statistic,

  contacts,
  chats,
  help,
  feedback,
]; // 9,

export const assistantLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  emplMyVideoPolls,
  notifications,
  myVacancies,
  myTasks,
  searchVacancy,
  favoriteVacancies,
  searchVacancy,
  favoriteResumes,
  responsesAndInvitations,

  contacts,
  chats,
  help,
  feedback,
  requestForRecord,
]; // 6,

export const assistantAdminLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  emplMyVideoPolls,
  notifications,
  controlPanel,
  tasksManagement,

  contacts,
  chats,
  help,
  feedback,
  requestForRecord,
]; // 7,

export const directorLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  notifications,
  controlPanel,
  tasksManagement,
  statistic,
  paymentsPanel,

  contacts,
  chats,
  help,
  feedback,
]; // 10,

export const founderLinks = [
  generalFeed,
  videoSession,
  myVideoSessions,
  notifications,
  controlPanel,
  tasksManagement,
  statistic,
  paymentsPanel,

  contacts,
  chats,
  help,
  feedback,
]; // 11
